import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import Helmet from 'react-helmet';
import { Box } from '@material-ui/core';

import { useAppointments } from '../context';
import TopBar from '../TopBar';
import SideMenu from '../SideMenu';
import useStyles from './styles';

const Frame = ({ children }) => {
  const classes = useStyles();
  const { productName } = useSelector(state => state.product);
  const { showSideMenu } = useAppointments();

  return (
    <Box className={classes.container}>
      <Helmet>
        <title>{`Agendamentos - ${productName}`}</title>
      </Helmet>
      <Box className={`content ${!showSideMenu && 'without-sidemenu'}`}>
        <TopBar />
        <SideMenu />
        <Box className="content-wrapper">
          <Box className="content-scrollable">{children}</Box>
        </Box>
      </Box>
    </Box>
  );
};

export default memo(Frame);
